<script>
    import { AppContent, Scrim } from '@smui/drawer';
    import Button, {Group, Label, Icon} from '@smui/button';

    export let nextPage="", previousPage="", nextPageEnabled = true;
</script>

<Scrim/>
<div class="background"></div>
<AppContent>
    <header class="mdc-top-app-bar mdc-top-app-bar--fixed">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <span class="mdc-top-app-bar__title">We-ID Enterprise oplossing</span>
            </section>
        </div>
        <div class="mdc-top-app-bar__row">
            {#if previousPage !== ""}
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <Button href={previousPage} class="navigation-button"><Icon class="material-icons">arrow_back</Icon><Label>terug</Label></Button>
            </section>
            {/if}
            {#if nextPage !== ""}
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                {#if nextPageEnabled}
                    <Button href={nextPage} class="navigation-button"><Label>volgende stap</Label><Icon class="material-icons">arrow_forward</Icon></Button>
                {:else}
                    <Button class="navigation-button not-allowed"><Label>volgende stap</Label><Icon class="material-icons">arrow_forward</Icon></Button>
                {/if}
            </section>
            {/if}
        </div>
    </header>
    <slot/>
</AppContent>
